export default {
  SET (state, tokens) {
    state.tokens = tokens
  }
}
